import { render, staticRenderFns } from "./giftCategoryList.vue?vue&type=template&id=2823a44c"
import script from "./giftCategoryList.vue?vue&type=script&lang=js"
export * from "./giftCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports